import $ from 'jquery';
import {findObjectById, getLocacion} from '../../util';



export class ConstanciaExternaApi {
    
      static saveAdjunto(file, token) {  
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken}, 
			url: "/api/constanciaExterna/cargarConstancia",
             
            contentType: false,
            processData: false,            
            type: 'POST',
			data: file,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location ='/login';
				}
			}
		});
	}
    
}